import React from "react";
import { IconProps } from "./IconProps";

const TagIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.6528 9.70379L10.2964 2.34742C10.1867 2.23688 10.0562 2.14925 9.91237 2.08961C9.76855 2.02997 9.61431 1.99951 9.45861 2.00001H2.5926C2.43544 2.00001 2.28471 2.06244 2.17357 2.17357C2.06244 2.28471 2.00001 2.43544 2.00001 2.5926V9.45861C1.99951 9.61431 2.02997 9.76855 2.08961 9.91237C2.14925 10.0562 2.23688 10.1867 2.34742 10.2964L9.70379 17.6528C9.81385 17.7629 9.94452 17.8502 10.0883 17.9098C10.2321 17.9693 10.3863 18 10.542 18C10.6976 18 10.8518 17.9693 10.9956 17.9098C11.1394 17.8502 11.27 17.7629 11.3801 17.6528L17.6528 11.3801C17.7629 11.27 17.8502 11.1394 17.9098 10.9956C17.9693 10.8518 18 10.6976 18 10.542C18 10.3863 17.9693 10.2321 17.9098 10.0883C17.8502 9.94452 17.7629 9.81385 17.6528 9.70379ZM10.5416 16.815L3.1852 9.45861V3.1852H9.45861L16.815 10.5416L10.5416 16.815ZM6.7408 5.8519C6.7408 6.02771 6.68866 6.19957 6.59099 6.34574C6.49332 6.49192 6.35449 6.60586 6.19207 6.67313C6.02964 6.74041 5.85091 6.75802 5.67848 6.72372C5.50605 6.68942 5.34767 6.60476 5.22335 6.48045C5.09904 6.35613 5.01438 6.19774 4.98008 6.02531C4.94578 5.85289 4.96339 5.67416 5.03066 5.51173C5.09794 5.34931 5.21188 5.21048 5.35805 5.11281C5.50423 5.01513 5.67609 4.963 5.8519 4.963C6.08765 4.963 6.31374 5.05665 6.48045 5.22335C6.64715 5.39005 6.7408 5.61615 6.7408 5.8519Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default TagIcon;
